<template>
  <div class="voting-module">
    <div class="title-box pt-4">
      <h4>{{this.$route.params.title}}</h4>
      <div class="candidate-des">{{this.$route.params.des}}</div>
    </div>

    <div class="candidates-lists">

      <div class="item-container">


        <div class="d-flex flex-row mt-5 p-2 " v-for="i in rowCount">
          <div class="col-6" v-for="(item,key) in itemCountInRow(i)" :key="item.id">
            <div class="card candidate-item">
              <img class="mx-auto" :src="`https://kishoto.ir/dtr/approid/img/${item.img}`" />
              <p class="candidate-name">{{ item.name }}</p>
              <div class="candidate-des d-flex flex-row p-2 d-flex justify-content-evenly text-center w-100">
                <button type="button" class="btn show-btn" @click="openCandidate(item.vpid,vlid)">نمایش اجرا</button>
                <button v-if="item.allow_vote" type="button" class="btn vote-btn" @click="votePerson(item,key,true)">رای دادن</button>
                <button v-else type="button" class="btn vote-btn active" @click="votePerson(item,key,false)">حذف رای</button>
              </div>
              <strong>{{item.result}}</strong>
            </div>
          </div>
        </div>


      </div>


    </div>

  </div>
</template>

<script>

import PlusIcon from 'vue-material-design-icons/Plus.vue';

import store from "@/store";

export default {
  data() {
    return {
      lists: [],
      itemsPerRow:2,
      resultVoted: null,
      votesVoted: null,
      vlid:null,
      votingtext:"رای دادن"
    };
  },
  components:{
    PlusIcon
  },
  created() {
      this.getCandidates();
      this.vlid = this.$route.params.id;
  },
  computed:{
    rowCount:function() {
      return Math.ceil(this.lists.length / this.itemsPerRow);
    }
  },
  methods: {
    async getCandidates() {
      let fd = new FormData();
      fd.append("vlid", this.$route.params.id);
      fd.append("token", store.state.login.loginTempToken);

      const response = await this.$ApiServiceLayer.post("get_votes_persons",fd);
      if (response.status_code === 200) {
        this.lists = response.list;
      }
    },
    itemCountInRow:function(index){
      return this.lists.slice((index - 1) * this.itemsPerRow, index * this.itemsPerRow)
    },
    async votePerson(item,key,voting){

      if(voting){
          this.votingtext = "حذف رای";
      }else{
          this.votingtext = "رای دادن";
      }

      let fd = new FormData();
      fd.append("vlid", this.$route.params.id);
      fd.append("vpid", item.vpid);
      fd.append("token", store.state.login.loginTempToken);

      const response = await this.$ApiServiceLayer.post("submit_vote",fd);

      if (response.status_code === 200) {
        this.resultVoted = response.result;
        this.votesVoted = response.vote;
      }

      this.getCandidates();
      /*this.$set(this.lists,key,{
        "vpid": item.id,
        "count":this.votesVoted+this.lists[key].count,
        "name": item.name,
        "active": item.active,
        "status": item.status,
        "allow_vote": false,
        "img": item.img,
        "result": this.resultVoted
      });*/

    },
    openCandidate(id,vlid){
      this.$router.push({name:`candidate-single`,params:{id:id,vlid:vlid}});
    }
  },
};
</script>

<style lang="scss" scoped>
.voting-module {
  width: 100%;
  min-height: 100vh;
  background-image: url("~@/assets/img/bg/talent_back.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0px;
  direction: rtl;
  .title-box{
    h4{
      text-align: center;
    }
    .candidate-des{
      text-align: center;
    }
  }
  .candidate-item{
    border-radius: 17px !important;
    border: none;
    box-shadow: 1px 3px 14px #8080804f;
    .candidate-name{
      text-align: center;
      border-bottom: 1px solid #9e9e9e;
      padding-bottom: 5px;
      padding-top: 11px;
      width: 90%;
      margin: 0 auto;
    }
    .candidate-des{
      .show-btn{
        background: #536DFE;
        border-radius: 108px;
        padding: 3px 10px 3px 10px;
        color: #ffffff;
        margin-bottom: 10px;
      }

      .vote-btn{
        background: #ffffff;
        border:1px solid #e91e63;
        border-radius: 108px;
        padding: 3px 10px 3px 10px;
        color: #e91e63;
        margin-bottom: 10px;
      }

      .vote-btn.active{
        background: #e91e63;
        border:1px solid #e91e63;
        border-radius: 108px;
        padding: 3px 10px 3px 10px;
        color: #ffffff;
        margin-bottom: 10px;
      }
    }
    img{
      width: 55%;
      border-radius: 50%;
      border: 3px solid black;
      margin-top: 15px;
    }
    strong{
      font-size: 17px;
      text-align: center;
      padding-bottom: 7px;
    }
  }
}
</style>
